export default "__VITE_ASSET__DFTacJaX__"